import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import VideoEmbed from './VideoEmbed';
import { isValid, isText } from '../../../../utils';

class VideoHero extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { categoryText=null, article={}, moduleData=null } = this.props;
		const { headline=null } = article;
		const { embed=null, jwplayer=null, videoEmbedLayout=null } = moduleData;
		const data = {
			hed: null, 
			hedBody: null, 
			subhed: null, 
			bodyText: null,
			embed,
			jwplayer,
			videoEmbedLayout: videoEmbedLayout
		};
		return (
			<div className="video-hero">
				<VideoEmbed className='video-embed' data={data} />
			</div>
		);
	}
}

export default VideoHero;
